import React, { useEffect, useState } from 'react'
import ReportHeader from '../../../../common/ReportHeader'
import { Box, Button, Grid } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { onlineReportMenu, reportMenu } from '../../../../../redux/Actions'
import CustomDatePicker from '../../../../common/CustomDatePicker'
import MultiSelectDropDown from '../../../../form-components/MultiSelectDropDownComponent'
import excelExport from '../../../../../assets/extra/export-excel'
import { TableHeaderColumn, excelConfig } from './Constants'
import jsPDF from 'jspdf'
import { callAddFontRobotoBold } from '../../../../../assets/fonts/Roboto-bold'
import { callAddFontRobotoNormal } from '../../../../../assets/fonts/Roboto-normal'
import { calculateDynamicFormatLandscape, calculateDynamicFormatPortrait, calculateTotalTableWidth } from '../../AccountsReports/PreponePostpone/Constants'
import autoTable from 'jspdf-autotable'
import { focusElemnt, formatDate, navigation1, navigation3 } from '../../../../../utilityFunctions'
import moment from 'moment'
import Alert from '../../../../common/Alert'
import { getCancelTransactionSummary } from '../../../../../redux/KSRTC_Redux/ReportsPage/ReportsAction'
import { getTotalByKey } from '../../../../generics/helper'
import CancelTransactionSummaryTable from './CancelTransactionSummaryTable'
import { getPaymentGatewayList } from '../../../../../redux/KSRTC_Redux/MasterConfig/MasterAction'
const CancelTransactionSummary = () => {
    const dispatch = useDispatch()
    const store = useSelector((store) => store);
    const { user, masterConfig } = store
    const { paymentGatewayList } = masterConfig
    const [filters, setFilters] = useState(
        {
            fromDate: formatDate(window.getTime ? window.getTime() : new Date()), toDate: formatDate(window.getTime ? window.getTime() : new Date()),
            pgType: [],
        })
    const [showAlert, setShowAlert] = useState(false);
    const [alertMsg, setAlertMsg] = useState("");
    const [showReport, setShowReport] = useState(false)
    const [reportTableData, setReportTableData] = useState({})
    const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm');
    useEffect(() => {
        focusElemnt('fromCancelDate')
    }, [])
    useEffect(() => {
        if (user?.CompanyID) {
            const paymentGatewayBody = { PGID: 0, }
            dispatch(getPaymentGatewayList(paymentGatewayBody, true, 60 * 60 * 1000))
        }
    }, [user?.CompanyID])
    useEffect(()=>{
        if (paymentGatewayList?.length > 0) {
            setFilters((prev) => ({ ...prev, pgType: [paymentGatewayList[0]] }))
        }
    },[paymentGatewayList])
    const paymentTypeProps = () => {
        return {
            id: 'paymentType',
            width: "100%",
            name: "paymentType",
            label: "",
            isCompulsory: false,
            options: paymentGatewayList || [],
            preSelectedValues: filters?.pgType,
            searchPlaceholder: "Search by Payment Gateway Type",
            disabled: false,
            isObject: true,
            primaryKey: 'PGID',
            labelKey: 'PGName',
            singleSelect: true,
            // selectAllOption: false,
            // defaultAllSelected: true,
            prevId: "toCancelDate",
            nextId: "submitBTN",
        }
    }

    const handleAlert = (msg) => {
        setShowAlert(true)
        setAlertMsg(msg)
    }
    const groupData = (array) => {
        let newData = []
        let totalarray = []
        let groupedData = array.reduce((result, item) => {
            // const key = `${item.PGName}`
            const key = item.PGName === 'RAZORPAY' ? 'Kotak - Razorpay' : `Kotak - Easebuzz`
            if (!result[key]) {
                result[key] = []
            } result[key].push(item)
            return result
        }, {})
        Object.keys(groupedData).forEach((key) => {
            const keys = ["TxnCount", "Amount", "RefundedCount", "RefundedAmount", "RefundedPtc", "PendingCount", "PendingAmount", "PendingPtc"];
            let updatedData = groupedData[key]?.map((val, i) => ({ ...val, isDataRow: true, }));
            let totals = getTotalByKey(groupedData[key], keys);
            totals = {
                ...totals,
                Amount: Math.round(Number(totals?.Amount)),
                RefundedAmount: Math.round(Number(totals?.RefundedAmount)),
                PendingAmount: Math.round(Number(totals?.PendingAmount)),
                RefundedPtc: Math.round((totals.RefundedCount * 100) / totals.TxnCount),
                PendingPtc: Math.round((totals.PendingCount * 100) / totals.TxnCount),
            }
            totals.totalCaption = "Total"
            totals.isTotalRow = true
            totals.totalCaptionAllignment = 'left'
            totals.colSpan = 1
            totalarray.push(totals)
            updatedData.push(totals)
            updatedData.unshift({ isHeaderRow: true, TxnDate: 'Date', TxnCount: 'Txn', Amount: 'Amount', RefundedCount: 'Txn', RefundedAmount: 'Amount', RefundedPtc: '%', PendingCount: 'Txn', PendingAmount: 'Amount', PendingPtc: '%' },)
            updatedData.unshift({ isSubHeadingRow: true, isSubHeading: true, subHeadingData: [{ caption: 'Total Cancelled', value: '', colSpan: 3 }, { caption: 'Total Refund', value: '', colSpan: 3 }, { caption: 'Pending Refund', value: '', colSpan: 3 }] })
            updatedData.unshift({ isSubHeadingRow: true, isSubHeading: true, subHeadingData: [{ caption: key, value: '', colSpan: 9 }] })
            newData = [...newData, ...updatedData]
        })
        const keys = ["TxnCount", "Amount", "RefundedCount", "RefundedAmount", "RefundedPtc", "PendingCount", "PendingAmount", "PendingPtc"];
        let allTotal = getTotalByKey(totalarray, keys);
        allTotal = {
            ...allTotal,
            Amount: Math.round(Number(allTotal?.Amount)),
            RefundedAmount: Math.round(Number(allTotal?.RefundedAmount)),
            PendingAmount: Math.round(Number(allTotal?.PendingAmount)),
            RefundedPtc: Math.round((allTotal.RefundedCount * 100) / allTotal.TxnCount),
            PendingPtc: Math.round((allTotal.PendingCount * 100) / allTotal.TxnCount),
        }
        allTotal.totalCaption = "Grand Total"
        allTotal.isTotalRow = true
        allTotal.totalCaptionAllignment = 'left'
        allTotal.colSpan = 1
        newData.push(allTotal)
        return newData
    }
    const reportExcelExport = async () => {
        if ((moment(filters?.toDate).startOf().diff(moment(filters?.fromDate).endOf(), 'days')) > 30) {
            handleAlert("This report cannot be taken for more than 31 days")
        } else {
            const body = {
                CompanyID: user?.CompanyID,
                UserID: user?.UserID,
                TxnDateFrom: filters?.fromDate,
                TxnDateTo: filters?.toDate,
                PGType: filters?.pgType?.[0]?.PGUsed,
            }
            const res = await dispatch(getCancelTransactionSummary(body));
            if (res.status === 200 && res.data.status) {
                let reportData = [];
                if (res.data?.Data?.Table?.length > 0) {
                    reportData = groupData(res.data?.Data?.Table)
                }
                const xlColumns = TableHeaderColumn.map((col) => {
                    return { colHeader: col.headerNameV2, field: col.field, xlCol: col.xlCol }
                });
                const xlConfig = {
                    ...excelConfig,
                    columns: xlColumns,
                    fileName: `CANCELLED_TRANSACTION_SUMMARY.xlsx`,
                    showFilterSection: true,
                    showSummarySection: true,
                    showEmptyRow: true,
                    headerRowStyle: { fill: '', bold: true },
                    borderStyle: {
                        top: { style: 'thin' },
                        left: { style: 'thin' },
                        bottom: { style: 'thin' },
                        right: { style: 'thin' }
                    },
                    showHeader: false,
                    workSheetTitle: `CANCELLED_TRANSACTION_SUMMARY`,
                    headerFooter: {
                        firstHeader: "CANCELLED_TRANSACTION_SUMMARY",
                        firstFooter: "CANCELLED_TRANSACTION_SUMMARY"
                    },
                    sheetHeaderData: [
                        {
                            "caption": "KARNATAKA STATE ROAD TRANSPORT CORPORATION",
                            "colSpan": 9,
                            "horizontal": "center",
                            "newRow": true
                        },
                        {
                            "caption": "CANCELLED TRANSACTION SUMMARY",
                            "colSpan": 9,
                            "size": 12,
                            "horizontal": "center",
                            "newRow": true
                        },
                        {
                            "caption": "From Date : ",
                            "value": `${moment(filters?.fromDate).format("DD-MMM-YYYY")} -To Date:${moment(filters?.toDate).format("DD-MMM-YYYY")}`,
                            "colSpan": 5,
                            "size": 10,
                        },
                        {
                            "caption": "User : ",
                            "value": `${user?.UserName || ''} (${sessionStorage.getItem('LoginId') || ""})`,
                            "colSpan": 4,
                            "horizontal": "right",
                            "size": 10,
                            "newRow": true
                        },
                        {
                            "caption": "Print Date & Time : ",
                            "value": `${currentDateTime}`,
                            "colSpan": 9,
                            "horizontal": "right",
                            "size": 10
                        },
                        // {
                        //     "caption": "From Date: ",
                        //     "value": `From Date:${moment(filters?.fromDate).format("DD-MMM-YYYY")} -To Date:${moment(filters?.toDate).format("DD-MMM-YYYY")}`,
                        //     "colSpan": 5,
                        //     "size": 10,
                        // },
                        // {
                        //     "caption": "To Date:",
                        //     "value": `${user?.UserName} ${moment().format('DD/MM/YYYY HH:mm:ss')}`,
                        //     "colSpan": 4,
                        //     "horizontal": "right",
                        //     "size": 10
                        // },
                    ],
                };
                await excelExport.processExcel(xlConfig, reportData, []);
            }
        }
    }
    const pdfGroupData = (array) => {
        let newData = []
        let totalarray = []
        let groupedData = array.reduce((result, item) => {
            // const key = `${item.PGName}`
            const key = item.PGName === 'RAZORPAY' ? 'Kotak - Razorpay' : `Kotak - Easebuzz`
            if (!result[key]) {
                result[key] = []
            } result[key].push(item)
            return result
        }, {})
        Object.keys(groupedData).forEach((key) => {
            let updatedData = [...groupedData[key]]
            const keys = ["TxnCount", "Amount", "RefundedCount", "RefundedAmount", "RefundedPtc", "PendingCount", "PendingAmount", "PendingPtc"];
            let totals = getTotalByKey(groupedData[key], keys);
            totals = {
                ...totals,
                Amount: Math.round(Number(totals?.Amount)),
                RefundedAmount: Math.round(Number(totals?.RefundedAmount)),
                PendingAmount: Math.round(Number(totals?.PendingAmount)),
                RefundedPtc: Math.round((totals.RefundedCount * 100) / totals.TxnCount),
                PendingPtc: Math.round((totals.PendingCount * 100) / totals.TxnCount),
            }
            totals.TxnDate = "Total"
            totals.isTotal = true
            totalarray.push(totals)
            updatedData.push(totals)
            updatedData.unshift({ isHeaderRow: true, TxnDate: 'Date', TxnCount: 'Txn', Amount: 'Amount', RefundedCount: 'Txn', RefundedAmount: 'Amount', RefundedPtc: '%', PendingCount: 'Txn', PendingAmount: 'Amount', PendingPtc: '%' },)
            updatedData.unshift({ TxnCount: "Total Cancelled", RefundedCount: "Total Refund", PendingCount: "Pending Refund", isSubHeading: true })
            updatedData.unshift({ TxnDate: key, isHeading: true })
            newData = [...newData, ...updatedData]
        })
        const keys = ["TxnCount", "Amount", "RefundedCount", "RefundedAmount", "RefundedPtc", "PendingCount", "PendingAmount", "PendingPtc"];
        let allTotal = getTotalByKey(totalarray, keys);
        allTotal = {
            ...allTotal,
            Amount: Math.round(Number(allTotal?.Amount)),
            RefundedAmount: Math.round(Number(allTotal?.RefundedAmount)),
            PendingAmount: Math.round(Number(allTotal?.PendingAmount)),
            RefundedPtc: Math.round((allTotal.RefundedCount * 100) / allTotal.TxnCount),
            PendingPtc: Math.round((allTotal.PendingCount * 100) / allTotal.TxnCount),
        }
        allTotal.TxnDate = "Grand Total"
        allTotal.isTotal = true
        newData.push(allTotal)
        return newData
    }

    const generatepdf = async () => {
        if ((moment(filters?.toDate).startOf().diff(moment(filters?.fromDate).endOf(), 'days')) > 30) {
            handleAlert("This report cannot be taken for more than 31 days")
        } else {
            const body = {
                CompanyID: user?.CompanyID,
                UserID: user?.UserID,
                TxnDateFrom: filters?.fromDate,
                TxnDateTo: filters?.toDate,
                PGType: filters?.pgType?.[0]?.PGUsed,
            }
            const res = await dispatch(getCancelTransactionSummary(body));
            if (res.status === 200 && res.data.status) {
                let reportData = [];
                if (res.data?.Data?.Table?.length > 0) {
                    reportData = pdfGroupData(res.data?.Data?.Table)
                }

                jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
                jsPDF.API.events.push(["addFonts", callAddFontRobotoNormal]);

                const pdfColumns = TableHeaderColumn.map((col) => {
                    return { header: col.headerName, dataKey: col.field, xlCol: col.xlCol, headerSx: col.headerSx }
                })
                const widthCell = calculateTotalTableWidth(TableHeaderColumn)
                // const doc = new jsPDF({ orientation: 'l', format: [1080, 1528], unit: 'px', compress: true })
                const doc = new jsPDF({ orientation: pdfColumns.length > 12 ? 'l' : 'p', format: pdfColumns.length > 12 ? calculateDynamicFormatLandscape((widthCell > 1122 ? widthCell : 1122) + 60) : calculateDynamicFormatPortrait((widthCell > 793 ? widthCell : 793) + 60), unit: 'px', compress: true })
                // var pageSize = doc.internal.pageSize
                doc.autoTableSetDefaults({
                    headStyles: { fontSize: 6, width: 'auto', halign: 'right', fillColor: [30, 89, 167] },
                })
                var totalPagesExp = '{total_pages_count_string}'
                doc.setProperties({
                    title: `Online Report.pdf`,
                    subject: 'Report',
                    author: 'Karnataka State Road Transport Corporation',
                    keywords: 'Mantis Technologies Private Limited',
                    creator: 'KSRTC',
                })
                autoTable(doc, {
                    margin: { top: 180, left: 30, right: 30, bottom: 40 },
                    alternateRowStyles: {
                        fillColor: [255, 255, 255],
                    },
                    columns: pdfColumns,
                    body: reportData,
                    columnStyles: {
                        0: { halign: 'left', fontSize: 14, minCellHeight: 36, cellPadding: 6, valign: 'middle', minCellWidth: 37, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                        1: { halign: 'right', fontSize: 14, minCellHeight: 36, cellPadding: 6, valign: 'middle', minCellWidth: 37, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                        2: { halign: 'right', fontSize: 14, minCellHeight: 36, cellPadding: 6, valign: 'middle', minCellWidth: 37, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                        3: { halign: 'right', fontSize: 14, minCellHeight: 36, cellPadding: 6, valign: 'middle', minCellWidth: 37, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                        4: { halign: 'right', fontSize: 14, minCellHeight: 36, cellPadding: 6, valign: 'middle', minCellWidth: 37, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                        5: { halign: 'right', fontSize: 14, minCellHeight: 36, cellPadding: 6, valign: 'middle', minCellWidth: 37, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                        6: { halign: 'right', fontSize: 14, minCellHeight: 36, cellPadding: 6, valign: 'middle', minCellWidth: 37, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                        7: { halign: 'right', fontSize: 14, minCellHeight: 36, cellPadding: 6, valign: 'middle', minCellWidth: 37, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                        8: { halign: 'right', fontSize: 14, minCellHeight: 36, cellPadding: 6, valign: 'middle', minCellWidth: 37, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                    },
                    showHead: 'never',
                    theme: 'grid',
                    styles: {
                        lineWidth: [0, 0.2, 0, 0.6],
                    },
                    tableLineWidth: 0.6,
                    headStyles: {
                        fontSize: 16,
                        fillColor: [255, 255, 255],
                        textColor: [0, 0, 0],
                        cellPadding: 6,
                        valign: 'middle',
                        fontStyle: 'normal',
                        font: 'Roboto',

                    },
                    didParseCell: (data) => {
                        // drawCell(data)
                        if (data.row.section === 'head') {
                            if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
                                data.cell.styles.halign = 'right'
                            } else {
                                data.cell.styles.halign = 'left'
                            }
                        }
                    },
                    didDrawPage: function (data) {
                        var doc = data.doc;
                        doc.setTextColor('#000000');

                        // Calculate text width and center for the first text
                        var text1 = 'KARNATAKA STATE ROAD TRANSPORT CORPORATION';
                        var textWidth1 = doc.getStringUnitWidth(text1) * doc.internal.getFontSize() / doc.internal.scaleFactor;
                        var centerX1 = (doc.internal.pageSize.width - textWidth1) / 2;

                        // Set font size and style for the first text
                        doc.setFontSize(18).setFont("Roboto", 'normal', '700');
                        doc.setTextColor('#000000');
                        // Draw the first text at the calculated x-coordinate
                        doc.text(text1, centerX1, 60);

                        // Set font size, weight, and color for the second text
                        doc.setFontSize(14).setFont("Roboto", 'normal', '600');
                        doc.setTextColor('#000000');
                        // Calculate text width and center for the second text
                        var text2 = 'CANCELLED TRANSACTION SUMMARY';
                        var textWidth2 = doc.getStringUnitWidth(text2) * doc.internal.getFontSize() / doc.internal.scaleFactor;
                        var centerX2 = (doc.internal.pageSize.width - textWidth2) / 2;
                        // Draw the second text at the calculated x-coordinate below the first text
                        doc.text(text2, centerX2, 80); // Adjust the vertical position as needed
                        doc.setTextColor(0, 0, 0)
                        doc.setFontSize(18)
                        doc.setFont('Roboto', '')
                        doc.text(`From Date:${moment(filters?.fromDate).format("DD-MMM-YYYY")} -To Date:${moment(filters?.toDate).format("DD-MMM-YYYY")}`, 30, 170)
                        // doc.setFontSize(18)
                        // doc.setFont('Roboto', '')
                        // doc.text(`From Date : Mtmm /21/Feb/2024/15:45:00`, 30, 145)
                        doc.setFontSize(18)
                        doc.setFont('Roboto', '')
                        doc.text(`User : ${user?.UserName || ''} (${sessionStorage.getItem('LoginId') || ""})`, doc.internal.pageSize.width - data.settings.margin.left, 145, 'right')
                        doc.text(`Print Date & Time : ${currentDateTime}`, doc.internal.pageSize.width - data.settings.margin.left, 170, 'right')
                    },
                })
                doc.setFont('Roboto')

                if (typeof doc.putTotalPages === 'function') {
                    doc.putTotalPages(totalPagesExp)
                }
                doc.save(`CANCELLED TRANSACTION SUMMARY ${new Date().getTime()}.pdf`)
            }
        }
    }

    const handleResetValue = () => {
        setFilters({
            fromDate: formatDate(window.getTime ? window.getTime() : new Date()),
            toDate: formatDate(window.getTime ? window.getTime() : new Date()),
            pgType: [paymentGatewayList[0]||[]],
        })
    }
    const handleSumbit = async () => {
        setShowReport(false)
        setReportTableData({})
        if ((moment(filters?.toDate).startOf().diff(moment(filters?.fromDate).endOf(), 'days')) > 30) {
            handleAlert("This report cannot be taken for more than 31 days")
        } else {
            const headerData = {
                fromDate: filters?.fromDate,
                toDate: filters?.toDate,
            };
            const body = {
                CompanyID: user?.CompanyID,
                UserID: user?.UserID,
                TxnDateFrom: filters?.fromDate,
                TxnDateTo: filters?.toDate,
                PGType: filters?.pgType?.[0]?.PGUsed,
            }
            dispatch(getCancelTransactionSummary(body)).then((res) => {
                if (res?.status === 200 && res?.data?.status) {
                    if (res?.data?.Data?.Table?.length > 0) {
                        setShowReport(true)
                        setReportTableData({ header: headerData, TableData: res?.data?.Data?.Table })
                    } else {
                        handleAlert('No Data Found!');
                        setReportTableData({ header: headerData, TableData: [] })
                    }
                } else {
                    handleAlert(res.data?.Message);
                }
            })
        }
    }

    return (
        <>
            {!showReport ?
                <Box>
                    <ReportHeader mainHeaderName='Report' headerName='Online Report' openSubMenu={() => dispatch(reportMenu(true))} subHeader={'CANCELLED TRANSACTION SUMMARY'} subHeaderVisible={() => dispatch(onlineReportMenu(true))} mainMenuOpen={true} />
                    <Grid
                        container
                        spacing={0}
                        className="column-container"
                        style={{
                            padding: "16px 16px 58px 16px",
                        }}
                    >
                        <Grid item md={6.5}
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '16px'
                            }}
                        >
                            <Grid
                                container
                                direction='row'
                                style={{
                                    paddingRight: '30px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'start',
                                    fontWeight: '700'
                                }}
                            >
                                <Grid item md={4}>Booked Date</Grid>
                                <Grid item md={8}>
                                    <CustomDatePicker label={''} id="fromCancelDate" selectedDate={filters?.fromDate}
                                        onChange={(value) => {
                                            setFilters((prev) => ({
                                                ...prev,
                                                fromDate: formatDate(value),
                                                toDate: formatDate(value)
                                            }))
                                        }}
                                        minDate={'2024-06-19'}
                                        onKeyDown={(e) => {
                                            navigation1(e, "toCancelDate", "");
                                        }}
                                    />
                                </Grid>
                            </Grid>

                            <Grid
                                container
                                direction='row'
                                style={{
                                    paddingRight: '30px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'start',
                                    fontWeight: '700'
                                }}
                            >
                                <Grid item md={4}>To Booking Date</Grid>
                                <Grid item md={8}>
                                    <CustomDatePicker label={''} id="toCancelDate" selectedDate={filters?.toDate}
                                        onChange={(value) => {
                                            setFilters((prev) => ({
                                                ...prev,
                                                toDate: formatDate(value)
                                            }))
                                        }}
                                        minDate={filters?.fromDate}
                                        onKeyDown={(e) => {
                                            navigation1(e, "paymentType", "fromCancelDate");
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid
                                container
                                direction='row'
                                style={{
                                    paddingRight: '30px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'start',
                                    fontWeight: '700'
                                }}
                            >
                                <Grid item md={4}>Payment Gateway Type</Grid>
                                <Grid item md={8}>
                                    <MultiSelectDropDown
                                        {...paymentTypeProps()}
                                        onSelect={(val) => setFilters((prev) => ({
                                            ...prev,
                                            pgType: val
                                        }))}
                                    />
                                </Grid>
                            </Grid>
                            <Grid
                                container
                                direction='row'
                                style={{
                                    paddingRight: '30px',
                                    gap: '10px',
                                    flexWrap: 'nowrap'
                                }}
                            >
                                <Grid item md={4}>
                                </Grid>
                                <Grid item md={2}>
                                    <Button variant="contained" size="medium" id="submitBTN"
                                        className={`btn-orange`}
                                        onClick={() => handleSumbit()}
                                        // onClick={() => { navigate('/reports/onlineReports/CancelTransactionSummaryTable');setTimeout(()=>{
                                        //     focusElemnt('backBTN') 
                                        // },100)}}
                                        onKeyDown={(e) => navigation3(e, "pdfBTN", "paymentType", () => { })}
                                    >
                                        SUBMIT
                                    </Button>
                                </Grid>
                                <Grid item md={2}>
                                    <Button
                                        variant="outlined"
                                        size="medium"
                                        id="pdfBTN"
                                        className="btn-orange-outline"
                                        onClick={() => generatepdf(true)}
                                        onKeyDown={(e) => navigation3(e, "excelBTN", "submitBTN", () => { })}
                                    >
                                        PDF
                                    </Button>
                                </Grid>
                                <Grid item md={2}>
                                    <Button
                                        variant="outlined"
                                        size="medium"
                                        className="btn-orange-outline"
                                        id="excelBTN"
                                        onClick={reportExcelExport}
                                        onKeyDown={(e) => navigation3(e, "resetBTN", "pdfBTN", () => { })}
                                    >
                                        EXCEL
                                    </Button>
                                </Grid>
                                <Grid item md={2}>
                                    <Button
                                        variant="outlined"
                                        size="medium"
                                        id="resetBTN"
                                        className="btn-orange-outline"
                                        onClick={() => handleResetValue()}
                                        onKeyDown={(e) => navigation3(e, "", "excelBTN", () => { })}

                                    >
                                        RESET
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>

                    </Grid>
                </Box>
                :
                <CancelTransactionSummaryTable reportTableData={reportTableData} handleBack={() => {
                    setReportTableData({});
                    setShowReport(false)
                }} />
            }
            {showAlert && (
                <Alert
                    msg={alertMsg} alertType={"error"} close={() => setShowAlert(false)} buttonText="Ok"
                />
            )}
        </>
    )
}

export default CancelTransactionSummary